module.exports = __webpack_public_path__ + "static/img/logo_13.ae9919b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo/logo_13.png
// module id = ij7q
// module chunks = 1